import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUser, SignIn, useAuth } from '@clerk/clerk-react'
import { useStore } from '../context/StoreContext'

export default function AdminLogin() {
    const { isLoaded, isSignedIn, user } = useUser();
    const { setIsAdmin } = useStore();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoaded) return;

        if (isSignedIn && user) {
          console.log(user)
            const role = user.publicMetadata?.role;
            console.log(role)
            
            if (role === 'admin' || role === 'superadmin') {
                setIsAdmin(true);
                navigate('/adminpanel');
            } else {
                // Not an admin, redirect to home
                setIsAdmin(false);
                navigate('/');
            }
        }
    }, [isLoaded, isSignedIn, user, navigate, setIsAdmin]);

    // Show loading while Clerk is loading
    if (!isLoaded) {
        return (
            <div className='container d-flex justify-content-center align-items-center' style={{ minHeight: '60vh' }}>
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    // If not signed in, show Clerk SignIn component
    if (!isSignedIn) {
        return (
            <div className='container d-flex justify-content-center align-items-center' style={{ minHeight: '60vh' }}>
                <div className="text-center">
                    <h2 className="mb-4">Admin Login</h2>
                    <SignIn 
                        routing="hash"
                        afterSignInUrl="/adminlogin"
                    />
                </div>
            </div>
        );
    }

    // If signed in but checking role, show loading
    return (
        <div className='container d-flex justify-content-center align-items-center' style={{ minHeight: '60vh' }}>
            <div className="text-center">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Verifying access...</span>
                </div>
                <p className="mt-3">Verifying admin access...</p>
            </div>
        </div>
    );
}

